<template>
    <div class="">
    <template v-if="payments == true">
        <div v-if="payroll_process_batch == true && payrollTotalAmount < 1" class="alert-notification"><p>Batch with zero amount can not be processed.</p></div>
        <div>
            <!-- In future payment engine here -->
            <virtualAccountComponent v-if="$global.user_vr_corp == 'YES'" :paymentType="'employee_payment'" :payroll_id="payroll_id" :payrollTotalAmount="payrollTotalAmount" :payableTxnAmount="payableTxnAmount"></virtualAccountComponent>
            <fincaComponent v-else-if="paymentEngine == 'FINCA' " :paymentType="'employee_payment'" :payroll_id="payroll_id" :payrollTotalAmount="payrollTotalAmount" :payableTxnAmount="payableTxnAmount"></fincaComponent>
            <meezanComponent v-else-if="paymentEngine == 'MEEZAN' " :paymentType="'employee_payment'" :payroll_id="payroll_id" :payrollTotalAmount="payrollTotalAmount" :meezan_balance="meezan_balance" :payableTxnAmount="payableTxnAmount"></meezanComponent>
            <nbpFundsComponent v-else-if="paymentEngine == 'NBP_FUND' " :paymentType="'employee_payment'" :payroll_id="payroll_id" :payrollTotalAmount="payrollTotalAmount" :numberOfBeneficiaries="users.length" :payableTxnAmount="payableTxnAmount"></nbpFundsComponent>
            <easypaisaComponent v-else-if="paymentEngine == 'EASY_PAISA' " :paymentType="'employee_payment'" :payroll_id="payroll_id"></easypaisaComponent>
            <faysalComponent v-else-if="paymentEngine == 'FAYSAL' " :paymentType="'employee_payment'" :payroll_id="payroll_id"></faysalComponent>
            
            <div class="modal fade" id="sendToSecondApproverPopup" tabindex="-1" role="dialog" aria-labelledby="sendToCheckerLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-body send-to-checker-popup text-center p-4">
                            <span class="exclamation-outer">
                                <i class="fas fa-exclamation"></i>
                            </span>
                            <h2 class="mt-4 mb-3"> Wait! Are you sure everything is correct? </h2>
                            <button type="button" class="btn btn-primary sendtosecondapprover" @click="sendtosecondapprover()">Yes</button>
                            <button type="button" class="btn btn-primary" data-dismiss="modal" aria-label="Close">No</button>
                        </div>
                    </div>
                </div>
            </div>

            <!--Sent to Checker Modal -->
            <div class="modal fade" id="sendToChecker" tabindex="-1" role="dialog" aria-labelledby="sendToCheckerLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-body send-to-checker-popup text-center p-4">
                            <span class="exclamation-outer">
                                <i class="fas fa-exclamation"></i>
                            </span>
                            <h2 class="mt-4 mb-3"> Wait! Are you sure everything is correct? </h2>
                            <button type="button" class="btn btn-primary submit_form sendtochecker" @click="sendForChecker()">Yes</button>
                            <button type="button" class="btn btn-primary" data-dismiss="modal" aria-label="Close" > No</button>
                        </div>
                    </div>
                </div>
            </div>

            <!--Sent to Approver Modal -->
            <div class="modal fade" id="sendToApprover" tabindex="-1" role="dialog" aria-labelledby="sendToCheckerLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-body send-to-checker-popup text-center p-4">
                            <span class="exclamation-outer">
                                <i class="fas fa-exclamation"></i>
                            </span>
                            <h2 class="mt-4 mb-3"> Wait! Are you sure everything is correct?  </h2>
                            <button type="button" class="btn btn-primary sendtoapprover" @click = "sendForApprover()">Yes</button>
                            <button type="button" class="btn btn-primary" data-dismiss="modal" aria-label="Close" >No</button>
                        </div>
                    </div>
                </div>
            </div>

            <!--Archive Batch Modal -->
            <div class="modal fade" id="archiveBatch" tabindex="-1" role="dialog" aria-labelledby="sendToCheckerLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-body send-to-checker-popup text-center p-4">
                            <span class="exclamation-outer">
                                <i class="fas fa-exclamation"></i>
                            </span>
                            <h2 class="mt-4 mb-3"> Do you really want to archive?  </h2>
                            <button type="button" class="btn btn-primary delete"  @click="archiveBatch()">Yes</button>
                            <button type="button" class="btn btn-primary" data-dismiss="modal" aria-label="Close" >No</button>
                        </div>
                    </div>
                </div>
            </div>

            <!--Archive Batch and Duplicate Modal -->
            <div class="modal fade" id="archiveAndDuplicateBatch" tabindex="-1" role="dialog" aria-labelledby="sendToCheckerLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-body send-to-checker-popup text-center p-4">
                            <span class="exclamation-outer">
                                <i class="fas fa-exclamation"></i>
                            </span>
                            <h2 class="mt-4 mb-3"> Do you really want to archive and duplicate?  </h2>
                            <button type="button" class="btn btn-primary delete" @click="archiveAndDuplicateBatch()">Yes</button>
                            <button type="button" class="btn btn-primary" data-dismiss="modal" aria-label="Close" >No</button>
                        </div>
                    </div>
                </div>
            </div>

            <!--Delete Modal -->
            <div class="modal fade" id="deleteBatch" tabindex="-1" role="dialog" aria-labelledby="sendToCheckerLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-body send-to-checker-popup text-center p-4">
                            <span class="exclamation-outer">
                                <i class="fas fa-exclamation"></i>
                            </span>
                            <h2 class="mt-4 mb-3"> Do you really want to delete?  </h2>
                            <button type="button" class="btn btn-primary delete" @click="deleteBatch()">Yes</button>
                            <button type="button" class="btn btn-primary" data-dismiss="modal" aria-label="Close" >No</button>
                        </div>
                    </div>
                </div>
            </div>

            <!--Disapprove Modal -->
            <div class="modal fade" id="disapproveBatch" tabindex="-1" role="dialog" aria-labelledby="sendToCheckerLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-body send-to-checker-popup text-center p-4">
                            <span class="exclamation-outer">
                                <i class="fas fa-exclamation"></i>
                            </span>
                            <h2 class="mt-4 mb-3"> Do you really want to disapprove?  </h2>
                            <button type="button" class="btn btn-primary delete"  @click="disapproveBatch()">Yes</button>
                            <button type="button" class="btn btn-primary" data-dismiss="modal" aria-label="Close" >No</button>
                        </div>
                    </div>
                </div>
            </div>

            <!--Re upload Modal -->
            <div class="modal fade" id="reUploadBatch" tabindex="-1" role="dialog" aria-labelledby="sendToCheckerLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-body send-to-checker-popup text-center p-4">
                            <div class="form-group mb-3">
                                <textarea v-model="reupload_comment" placeholder="Why are you reuploading this batch?" class="form-control"></textarea>
                            </div>
                            <h2 class="mt-4 mb-3"> Do you really want to reupload?  </h2>
                            <button type="button" class="btn btn-primary delete" @click="reuploadBatch()" >Yes</button>
                            <button type="button" class="btn btn-primary" data-dismiss="modal" aria-label="Close" >No</button>
                        </div>
                    </div>
                </div>
            </div>

            <!--Reject Batch-->
            <!-- <div class="modal fade" id="rejectBatch" tabindex="-1" role="dialog" aria-labelledby="sendToCheckerLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content">
                        <div class="modal-body send-to-checker-popup text-center p-4">

                            <div class="form-group mb-3">
                                <textarea v-model="reject_comment" placeholder="Why are you rejecting this batch?" class="form-control"></textarea>
                            </div>

                            <h2 class="mt-4 mb-3"> Do you really want to reject this batch?  </h2>
                            <button type="button" class="btn btn-primary delete" @click="rejectBatch">Yes</button>
                            <button type="button" class="btn btn-primary" data-dismiss="modal" aria-label="Close" >No</button>
                        </div>
                    </div>
                </div>
            </div> -->

            <div class="page-top dropdown mb-1 mb-3 clearfix">
                <h1 class="float-left"> {{ payrollName }} <span class="highlight-color"> ({{ new Intl.NumberFormat().format(payrollTotalAmount) }} PKR) </span> </h1>

                <!-- request data -->
                <div style="display:none">{{payroll_id}}</div>
                <div v-if="payrollList != null">
                    <template v-if="payroll_process_batch == true && payrollTotalAmount > 0">
                        <button class="btn btn-primary float-right mr-1" data-toggle="modal" data-target="#loginMoblizer" v-if="((payrollList.status !==7 && payrollList.status !== 8 && payrollList.status !== 10) && (this.payrollList.no_of_approver < 2 && ( (this.isAlreadyApproved == false && this.payrollList.status <= 3) || this.payableTxn > 0) && this.$global.user_vr_corp == 'YES' && this.$global.user_vr_balance >= this.payableTxnAmount && this.users.length > 0))"> Process </button>
                        <button class="btn btn-primary float-right mr-1" data-toggle="modal" data-target="#loginMoblizer" v-else-if="((payrollList.status !==7 && payrollList.status !== 8 && payrollList.status !== 10) && (this.payrollList.no_of_approver < 2 && ( (this.isAlreadyApproved == false && this.payrollList.status <= 3) || this.payableTxn > 0) && this.processButton == true && this.$global.user_vr_corp == 'NO' && this.corporateAccountBalance >= this.payableTxnAmount && this.users.length > 0))"> Process </button>
                        <button class="btn btn-primary float-right mr-1" data-toggle="modal" data-target="#sendToSecondApproverPopup" v-else-if="(this.payrollList.no_of_approver > 1 && this.processButton == true && ( (this.isAlreadyApproved == false  && this.payrollList.status <= 3) || this.payableTxn > 0))"> Send To {{this.$global.nextApprover}} </button>
                    </template>
                    <template v-else-if="payroll_send_to_approver == true">
                        <button class="btn btn-primary float-right mr-1" v-if="payrollList.status <= 2 && sendForApproverButton == true && this.isAlreadyCheck == false" data-toggle="modal"  data-target="#sendToApprover"> Send To <template v-if="this.$global.nextChecker == ''">Approver</template><template v-else>{{this.$global.nextChecker}}</template> </button>
                    </template>
                    <template v-else-if="payroll_send_to_checker == true">
                        <button class="btn btn-primary float-right mr-1" v-if="(payrollList.status == 1 || payrollList.status == 7) && sendForCheckerButton == true && this.isAlreadySent == false" data-toggle="modal" data-target="#sendToChecker"> Send To  <template v-if="this.$global.nextMaker == ''">Checker</template><template v-else>{{this.$global.nextMaker}}</template>  </button>
                    </template>
                    <button class="btn btn-primary float-right mr-1" v-if="payrollList.status <= 3 && approverRejectButton == true" data-toggle="dropdown" data-placement="bottom" title="The batch will be sent back to checker for correction" @click="rejectApproverPopup()"> Revise Batch </button>
                    <button class="btn btn-primary float-right mr-1" v-if="payrollList.status <= 3 && disapproveButton == true" data-toggle="dropdown" data-placement="bottom" title="The batch will be cancelled completely" @click="disapprovePopup()"> Disapprove </button>
                    <!-- <button class="btn btn-primary float-right mr-1" v-if="this.failedArray.length > 0 && payrollList.status == 4" @click="showFailedModal()" data-toggle="tooltip" data-placement="bottom" title="The will only reprocess the failed transactions of this batch.">Reprocess</button> -->

                    <button class="btn btn-primary float-right mr-1" v-if="payrollList.status == 7 && reUploadButton == true" data-toggle="dropdown" @click="reUploadPopup()"> Re-upload </button>
                    <button class="btn btn-primary float-right mr-1" v-if="payrollList.status == 10 && batchStatusButton == true && paymentEngine == 'FINCA'" @click="batchStatus()" data-toggle="modal"> Batch Status </button>
                    <button class="btn btn-primary float-right mr-1" v-if="payrollList.status == 11 && archiveBatchButton == true" data-toggle="modal" data-target="#archiveBatch"> Archive Batch </button>
                    <button class="btn btn-primary float-right mr-1" v-if="payrollList.status == 11 && archiveBatchAndDuplicateButton == true" data-toggle="modal" data-target="#archiveAndDuplicateBatch"> Archive Batch & Create Duplicate </button>
                    <button class="btn btn-primary float-right mr-1" v-if="(payrollList.status == 1 || payrollList.status  == 7 )&& deletButton == true" data-toggle="modal" data-target="#deleteBatch"> Delete Batch </button>
                    <div class="dropdown-menu reupload-dropdown dropdown-menu-right">
                        <div class="dropdown-content">
                            <div class="user-section mb-3">
                                <span  v-if="currentUserImage != null" class="user-image">
                                <img v-bind:src="'/avatar/'+currentUserImage" alt="" class="user-image"/>
                                </span>
                                <span v-else class="user-image">{{currentUserFirstLetter}}</span>
                                <p class="">
                                    <span class="user-status user-name">{{currentUserName}}</span>
                                    <span class="user-status user-designation">{{currentUserRole[0]}}</span>
                                </p>
                            </div>
                            <form @submit.prevent="disapproveBatch"  v-if="commentAction == 'disapprove'">
                                <div class="form-group mb-3">
                                    <textarea placeholder="Why are you disapproving this batch?" class="form-control"  v-model="formDisapprove.comment"  name="comment" id="comment" :class="{ 'is-invalid': formDisapprove.errors.has('comment')}" ></textarea>
                                    <has-error :form="formDisapprove" field="comment"></has-error>
                                </div>
                                <div class="btn-holder text-right">
                                    <button type="" class="btn btn-primary btn-block disapprove" value="Submit"> Disapprove</button>
                                </div>
                            </form>
                            <form @submit.prevent="rejectBatch" v-if="commentAction == 'reject'">
                                <div class="form-group mb-3">
                                    <textarea placeholder="Why are you rejecting this batch?" class="form-control"  v-model="formReject.comment"  name="comment" id="comment" :class="{ 'is-invalid': formReject.errors.has('comment')}" ></textarea>
                                    <has-error :form="formReject" field="comment"></has-error>
                                </div>
                                <div class="btn-holder text-right">
                                    <button type="" class="btn btn-primary btn-block reject" value="Submit"> Revise</button>
                                </div>
                            </form>
                            <form @submit.prevent="reuploadBatch" v-if="commentAction == 'reUpload'">
                                <div class="form-group mb-3">
                                    <textarea placeholder="Why are you re-uploading this batch?" class="form-control"  v-model="formReUpload.comment"  name="comment" id="comment" :class="{ 'is-invalid': formReUpload.errors.has('comment')}" ></textarea>
                                    <has-error :form="formReUpload" field="comment"></has-error>
                                </div>
                                <div class="btn-holder text-right">
                                    <button type="" class="btn btn-primary btn-block reUpload" value="Submit"> Re-Upload</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <div class="head-date float-right mr-2">{{payrollDate}} <i class="fas fa-calendar-alt"></i> </div>
            </div>
            <div class="batch-history mb-3 clearfix" v-if="batchHistory != null">
                <h2> <span class="text"> Batch History </span> </h2>
                <ul class="batch-status-list">
                    <li class="status-list-item" v-for="bh in batchHistory" :key="bh.id">
                        <span class="status uploaded" v-if="bh.action == 'UPLOAD'"> Uploaded </span>
                        <span class="status flagged" v-if="bh.action == 'FLAGGED'"> Flagged
                            <!-- Show Flagged Comment -->
                            <div class="dropdown-menu reupload-dropdown flagged-message dropdown-menu-right">
                                <div class="dropdown-content">
                                    <div class="flag"> <img src="/images/flag.png'" alt="" /> </div>
                                    <div class="user-section mb-3">
                                        <span class="user-image">
                                            <img class="user-image" :src="'/avatar/'+bh.image" @error="$event.target.src = '/images/table-dummy-image.jpg'"/>
                                        </span>
                                        <p class="">
                                            <span class="user-status user-name">{{bh.username}}</span>
                                            <span class="user-status date">{{bh.updated_at}}</span>
                                        </p>
                                    </div>
                                    <div class="text">
                                        <p> {{bh.comment}} </p>
                                    </div>
                                </div>
                            </div>
                        </span>
                        <span class="status checked" v-if="bh.action == 'CHECKED'"> Checked </span>
                        <span class="status uploaded" v-if="bh.action == 'REUPLOAD'"> Re-uploaded
                            <!-- Show Reuploaded Comment -->
                            <div class="dropdown-menu reupload-dropdown flagged-message dropdown-menu-right">
                                <div class="dropdown-content">
                                    <div class="flag"> <img src="'/images/flag.png'" alt="" /> </div>
                                    <div class="user-section mb-3">
                                        <span class="user-image">
                                            <img class="user-image" :src="'/avatar/'+bh.image" @error="$event.target.src = '/images/table-dummy-image.jpg'"/>
                                        </span>
                                        <p class="">
                                            <span class="user-status user-name">{{bh.username}}</span>
                                            <span class="user-status date">{{bh.updated_at}}</span>
                                        </p>
                                    </div>
                                    <div class="text">
                                        <p> {{bh.comment}} </p>
                                    </div>
                                </div>
                            </div>
                        </span>
                        <span class="status flagged" v-if="bh.action == 'UNDERREVIEW'"> Under Review </span>
                        <span class="status completed" v-if="bh.action == 'APPROVED'"> Approved </span>
                        <span class="status rejected" v-if="bh.action == 'DISAPPROVED'"> Disapproved
                            <!-- Show Disapprove Comment -->
                            <div class="dropdown-menu reupload-dropdown flagged-message dropdown-menu-right">
                                <div class="dropdown-content">
                                    <div class="flag"> <img src="'/images/flag.png'" alt="" /> </div>
                                    <div class="user-section mb-3">
                                        <span class="user-image">
                                            <img class="user-image" :src="'/avatar/'+bh.image" @error="$event.target.src = '/images/table-dummy-image.jpg'"/>
                                        </span>
                                        <p class="">
                                            <span class="user-status user-name">{{bh.username}}</span>
                                            <span class="user-status date">{{bh.updated_at}}</span>
                                        </p>
                                    </div>
                                    <div class="text">
                                        <p> {{bh.comment}} </p>
                                    </div>
                                </div>
                            </div>
                        </span>
                        <span class="status archived" v-if="bh.action == 'ARCHIVED'"> Archived </span>
                    </li>
                </ul>
            </div>

            <div class="reconciliation-main mb-3" v-if="afterPayementBatchSummary == true || beforePayementBatchSummary == true">
                <h2 class="mb-3"> Batch Summary</h2>
                <div class="reconciliation-inner">                    
                    <div class="row mt-4 align-items-center">
                        <div class="col-md-3 text-right">
                            <span class="title float-none d-block p-0"> Total Payable Transactions: </span>
                        </div>
                        <div class="col-md-3"> <span class="amount d-block p-0"> {{ payableTxn }} </span> </div>                        
                        <div class="col-md-3 text-right">
                            <span class="text-right title float-none d-block p-0"> Total Volume: </span>
                        </div>
                        <div class="col-md-3"> <span class="amount d-block p-0"> Rs. {{ payableTxnAmount | formatAmount }} </span> </div>
                    </div>
                    <div class="row mt-4 align-items-center" v-if="afterPayementBatchSummary == true">
                        <div class="col-md-3 text-right">
                            <span class="title float-none d-block p-0"> Successfull Transactions: </span>
                        </div>
                        <div class="col-md-3"> <span class="amount d-block p-0"> {{ successTxn }} </span> </div>                        
                        <div class="col-md-3 text-right">
                            <span class="title float-none d-block p-0"> Total Volume: </span>
                        </div>
                        <div class="col-md-3"> <span class="amount d-block p-0"> Rs. {{ successTxnAmount | formatAmount }} </span> </div>
                    </div>
                    <div class="row mt-4 align-items-center" v-if="afterPayementBatchSummary == true">
                        <div class="col-md-3 text-right">
                            <span class="title float-none d-block p-0"> Unsuccessfull Transactions: </span>
                        </div>
                        <div class="col-md-3"> <span class="amount d-block p-0"> {{ failedTxn }} </span> </div>                        
                        <div class="col-md-3 text-right">
                            <span class="text-right title float-none d-block p-0"> Total Volume: </span>
                        </div>
                        <div class="col-md-3"> <span class="amount d-block p-0"> Rs. {{ failedTxnAmount | formatAmount }} </span> </div>
                    </div>
                    <div class="row mt-4 align-items-center" v-if="afterPayementBatchSummary == true">
                        <div class="col-md-3 text-right">
                            <span class="title float-none d-block p-0"> Pending Transactions: </span>
                        </div>
                        <div class="col-md-3"> <span class="amount d-block p-0"> {{ pendingTxnCount }} </span> </div>                        
                        <div class="col-md-3 text-right">
                            <span class="text-right title float-none d-block p-0"> Total Volume: </span>
                        </div>
                        <div class="col-md-3"> <span class="amount d-block p-0"> Rs. {{ pendingTxnAmount | formatAmount }} </span> </div>
                    </div>
                    <div class="row mt-4 align-items-center" v-if="afterPayementBatchSummary == true || beforePayementBatchSummary == true">
                        <div class="col-md-3 text-right">
                            <span class="title float-none d-block p-0"> Total Batch Transactions: </span>
                        </div>
                        <div class="col-md-3"> <span class="amount d-block p-0"> {{users.length}} </span> </div>                        
                        <div class="col-md-3 text-right">
                            <span class="text-right title float-none d-block p-0"> Total Volume: </span>
                        </div>
                        <div class="col-md-3"> <span class="amount d-block p-0"> Rs. {{ payrollTotalAmount | formatAmount }} </span> </div>
                    </div>
                    <div class="reconciliation-footer mt-4">
                        <div class="row mt-3 align-items-center mb-3" v-if="afterPayementBatchSummary == true || beforePayementBatchSummary == true ">
                            <div class="col-md-3 text-right">
                                <span class="text-right title float-none d-block"> Total Fee: </span>
                            </div>
                            <div class="col-md-2"v-if="transationfeeSum > 0"> <span class="amount d-block"> Rs. {{parseFloat(transationfeeSum.toFixed(4))}} </span> </div>
                            <div class="col-md-2"v-if="transationfeeSum == 0"> <span class="amount d-block"> Rs. {{transationfeeSum}} </span> </div>
                            <div class="col-md-7"v-if="transationfeeSum > 0"><span class=""><small><i class="fa fa-info-circle"></i> &nbsp Charges held for “Free IBFT limit” (Rs. 25,000 per month) will be refunded in your total balance.</small></span> </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="batch-process-history mb-3">
                <div class="batch-process-outer" v-for="bh in batchHistory" :key="bh.id" v-if="['UPLOAD','CHECKED','APPROVED','REUPLOAD','FLAGGED','DISAPPROVED'].includes(bh.action)">
                    <div class="batch-process-inner created-by"  v-if="bh.action == 'UPLOAD'">
                        <span class="action-by"> Created By </span>
                        <div class="process-content">
                            <div class="user">
                                <img :src="'/avatar/'+bh.image" @error="$event.target.src = '/images/table-dummy-image.jpg'"/>
                            </div>
                            <p class="batch-process-text">
                                <strong class="title" :title="bh.username"> {{ bh.username }} </strong>
                                {{bh.designation_name}}
                            </p>
                        </div>
                        <div class="created-date text-right"> {{ bh.created_at | date_format }} </div>
                    </div>
                    <div class="batch-process-inner checked-by" v-if="bh.action == 'CHECKED'">
                        <span class="action-by"> Checked By </span>
                        <div class="process-content">
                            <div class="user">
                                <img :src="'/avatar/'+bh.image" @error="$event.target.src = '/images/table-dummy-image.jpg'"/>
                            </div>
                            <p class="batch-process-text">
                                <strong class="title" :title="bh.username"> {{ bh.username }} </strong>
                                {{bh.designation_name}}
                            </p>
                        </div>
                        <div class="created-date text-right"> {{ bh.created_at | date_format }} </div>
                    </div>
                    <div class="batch-process-inner approved-by" v-if="bh.action == 'APPROVED'">
                        <span class="action-by"> Approved By </span>
                        <div class="process-content">
                            <div class="user">
                                <img :src="'/avatar/'+bh.image" @error="$event.target.src = '/images/table-dummy-image.jpg'"/>
                            </div>
                            <p class="batch-process-text">
                                <strong class="title" :title="bh.username"> {{ bh.username }} </strong>
                                {{bh.designation_name}}
                            </p>
                        </div>
                        <div class="created-date text-right"> {{ bh.created_at | date_format }} </div>
                    </div>
                    <div class="batch-process-inner reuploaded-by" v-if="bh.action == 'REUPLOAD'">
                        <span class="action-by"> Reuploaded By </span>
                        <div class="process-content">
                            <div class="user">
                                <img :src="'/avatar/'+bh.image" @error="$event.target.src = '/images/table-dummy-image.jpg'"/>
                            </div>
                            <p class="batch-process-text">
                                <strong class="title" :title="bh.username"> {{ bh.username }} </strong>
                                {{bh.designation_name}}
                            </p>
                        </div>
                        <div class="created-date text-right"> {{ bh.created_at | date_format }} </div>
                    </div>
                    <div class="batch-process-inner flagged-by" v-if="bh.action == 'FLAGGED'">
                        <span class="action-by"> Revised By </span>
                        <div class="process-content">
                            <div class="user">
                                <img :src="'/avatar/'+bh.image" @error="$event.target.src = '/images/table-dummy-image.jpg'"/>
                            </div>
                            <p class="batch-process-text">
                                <strong class="title" :title="bh.username"> {{ bh.username }} </strong>
                                {{bh.designation_name}}
                            </p>
                        </div>
                        <div class="created-date text-right"> {{ bh.created_at | date_format }} </div>
                    </div>
                    <div class="batch-process-inner disapprove-by" v-if="bh.action == 'DISAPPROVED'">
                        <span class="action-by"> Disapproved By </span>
                        <div class="process-content">
                            <div class="user">
                                <img :src="'/avatar/'+bh.image" @error="$event.target.src = '/images/table-dummy-image.jpg'"/>
                            </div>
                            <p class="batch-process-text">
                                <strong class="title" :title="bh.username"> {{ bh.username }} </strong>
                                {{bh.designation_name}}
                            </p>
                        </div>
                        <div class="created-date text-right"> {{ bh.created_at | date_format }} </div>
                    </div>
                    <div class="batch-process-inner archived-by" v-if="bh.action == 'ARCHIVED'">
                        <span class="action-by"> Archived By </span>
                        <div class="process-content">
                            <div class="user">
                                <img :src="'/avatar/'+bh.image" @error="$event.target.src = '/images/table-dummy-image.jpg'"/>
                            </div>
                            <p class="batch-process-text">
                                <strong class="title" :title="bh.username"> {{ bh.username }} </strong>
                                {{bh.designation_name}}
                            </p>
                        </div>
                        <div class="created-date text-right"> {{ bh.created_at | date_format }} </div>
                    </div>
                </div>
            </div>
            <div v-if="actual_status" class="alert alert-danger" role="alert">
                <p><b> Note! </b> Please be advised that any pending transactions will be reconciled and updated on T+1 or the next business day</p>
            </div>
            <div v-if="this.payrollList != null && (this.payrollList.status < 4 || this.payableTxn > 0) && this.$global.user_vr_corp == 'YES' && this.payableTxnAmount > this.$global.user_vr_balance" class="alert alert-danger" role="alert">
                <p><b> Warning! </b> Your account has insufficient balance for this batch to process. Current Balance : {{this.$global.user_vr_balance}}</p>
            </div>
            <div v-if="this.payrollList != null && (this.payrollList.status < 4 || this.payableTxn > 0) && this.$global.user_vr_corp == 'NO' && this.payableTxnAmount > this.corporateAccountBalance" class="alert alert-danger" role="alert">
                <p><b> Warning! </b> Your account has insufficient balance for this batch to process. Current Balance : {{this.corporateAccountBalance}}</p>
            </div>
            <div class="alert alert-warning" role="alert" v-if="account_msg !== ''">
                <p><b> Warning! </b>{{account_msg}}</p>
            </div>
            <div class="alert alert-warning" role="alert" v-if="unRegisterWalletCount > 0">
                <p><b> Warning! </b> Un-registered record(s) found in the batch.</p>
            </div>
            <div class="alert alert-danger" role="alert" v-if="failedTransactions==true">
                <p><b> Warning! </b> There are some failed transaction(s).</p>
            </div>
            <div class="btns-holder dropdown-btns clearfix mb-3" v-show="exportBatch">
                <div class="w-15 mr-2 float-left">
                    <select class="selectpicker custom-select2" @change="batchExport($event)">
                        <option value="">Export Batch</option>
                        <option value="complete">Complete</option>
                        <option value="pending">Pending</option>
                        <option value="successfull" v-if="afterPayementBatchSummary == true && successTxn > 0">Successfull</option>
                        <option value="failed"  v-if="afterPayementBatchSummary == true && failedTxn > 0">Failed</option>
                    </select>
                </div>
                <div class="w-15 mr-2 float-left">
                    <select class="selectpicker custom-select2" @change="printBatch($event)">
                        <option value="">Print Batch</option>
                        <option value="complete">Complete</option>
                        <option value="successfull" v-if="afterPayementBatchSummary == true && successTxn > 0">Successfull</option>
                        <option value="failed"  v-if="afterPayementBatchSummary == true && failedTxn > 0">Failed</option>
                    </select>
                </div>
                <a class="btn btn-primary float-left ml-1" v-if="unRegisterWalletCount > 0" @click="unRegisterWalletExport" href="javascript:void(0)"> Un-registered Record[s] </a>
                <a class="btn btn-primary float-left ml-1" v-if="failedTransactions == true" @click="failedTransactionsExport" href="javascript:void(0)"> Failed Transactions </a>
            <div class="filters-col m-0 float-right">
                <input type="text" id="customSearch" class="search form-control" placeholder="Search" name="search"/>
            </div>
            </div>
            <div class="table-holder mb-3">
                <table id="dt-payroll-payments" class="table table-responsive-xl" style="width:100%">
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Salary</th>
                            <th>Account Title</th>
                            <th>Additional Earnings</th>
                            <th>Reimbursements</th>
                            <th>Deductions</th>
                            <th>Fee</th>
                            <th>Net Payable</th>
                            <th v-if="flagTD == true" align="center">Flag</th>
                            <th v-if="payTD == true">Pay</th>
                            <th>Status</th>
                            <th v-if="downloadTD == true">Download</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="user in users" v-bind:key="user.id" :class="{ 'selected' : user.comments != '' }" >
                            <td class="">
                                <div class="image-title employe-detail-tooltip" :id="`employe-detail-tooltip-${user.id}`">
                                    {{employeeDetails(user)}}
                                    <div class="image-holder">
                                        <img :src="'/avatar/'+user.image" @error="$event.target.src = '/images/table-dummy-image.jpg'" style="width:40px; height:40px;"/>
                                    </div>
                                    <a href="javascript:void(0)" class="title" v-if="user.name != '' && user.name != null"> {{ user.name }} </a>
                                    <a href="javascript:void(0)" class="title" v-else> {{ user.username }} </a>
                                </div>
                            </td>
                            <td> <span class="empSalary" :id="`salary-detail-${user.id}`"> {{ employeeSalary(user.breakUp, user.id) }} </span></td>
                            <td> <span class="" v-if="user.payee_employee_beneficiary"> {{ user.payee_employee_beneficiary.account_title }} </span>
                            <span class="" v-else> --- </span>
                            </td>

                            <td> <span class="additionEarnings" :id="`addition-earnings-detail-${user.id}`"> {{ additionEarnings(user.breakUp, user.id) }} </span></td>
                            <td> <span class="otherReimbursment" :id="`other-reimbursment-detail-${user.id}`"> {{ otherReimbursment(user.breakUp, user.id) }} </span></td>
                            <td> <span class="deduction" :id="`deduction-detail-${user.id}`"> {{ deduction(user.breakUp, user.id) }} </span></td>
                            <td v-if="user.transactionfee > 0">{{ (user.transactionfee != null || user.transactionfee != '') ? parseFloat((parseFloat(user.transactionfee) + parseFloat(user.transactionfed)).toFixed(4)) : '---' }}</td>
                            <td v-else >0</td>
                            <td>{{ user.net_salary | formatAmount }}</td>
                            <td align="center" v-if="flagTD == true">
                                <span class="icon comment" @click="showCommentBox(user.comment_html,user.id)" data-toggle="popover-click"> <i class="far fa-comment-alt"></i> </span>
                            </td>
                            <td v-if="payTD == true || user.actual_status != 'Pending'">
                               <select v-if="!statusTD && (mca == true || (user.transfered == null && user.action != 'REJECT') && currentStatus !=10)" @change="updateRecordAction(user.id, $event)" class="form-control custom-select" name="action" id="">
                                   <option value="PAY" :selected="user.action == 'PAY'?'selected':''">Pay</option>
                                   <option value="HOLD" :selected="user.action == 'HOLD'?'selected':''">Hold</option>
                                   <option value="REJECT" :selected="user.action == 'REJECT'?'selected':''">Reject</option>
                               </select>
                            </td>
                            <td align="center">
                                <span class="status" v-if="user.transfered == 1 && user.action == 'PAY' && user.recon_status == 'NO'" style="border-color: #46a748;color: #46a748;">Paid </span>
                                <span class="status" v-if="user.transfered == 0 && user.action == 'REJECT' && user.recon_status == 'NO'" style="border-color: #eb401f; color: #eb401f;">Reject </span>
                                <span class="status pending" v-if="user.actual_status == 'Pending'" style="border-color: #ffc107; color: #ffc107;">Pending </span>
                            </td>
                            <td v-if="downloadTD == true"><a href="javascript:void(0);" data-toggle="tooltip" data-placement="top" title="Download" class="action" @click="downloadSalarySlip(user.id)" v-if="(user.action !== 'HOLD' && user.action !== 'REJECT')" ><i class="fas fa-download"></i></a></td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <!--Display Failed transactions Modal -->
            <!-- <div class="modal fade bd-example-modal-lg" id="displayFailed" tabindex="-1" role="dialog" aria-labelledby="sendToCheckerLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                    <div class="modal-content">
                        <div v-if="payroll_process_batch == true" class="p-2">
                            <div v-if="this.$global.user_vr_corp == 'YES' && (this.payrollStatus == 4 ) && this.failedSumNetSalary > this.$global.user_vr_balance" class="alert alert-danger" role="alert">
                                <p><b> Warning! </b> Your account has insufficient balance for this batch to reprocess. Current Balance : {{this.$global.user_vr_balance}}</p>
                            </div>
                            <div v-if="this.$global.user_vr_corp == 'NO' && (this.payrollStatus == 4) && this.failedSumNetSalary > this.corporateAccountBalance" class="alert alert-danger" role="alert">
                                <p><b> Warning! </b> Your account has insufficient balance for this batch to reprocess. Current Balance : {{this.corporateAccountBalance}}</p>
                            </div>
                            <button class="btn btn-primary float-right mr-1" data-toggle="modal" @click="showMobilizerModal" v-if="((this.payrollStatus == 4 ) && (this.$global.user_vr_corp == 'YES' && this.$global.user_vr_balance >= this.failedSumNetSalary && failedArray.length > 0))"> Reprocess </button>
                    
                            <button class="btn btn-primary float-right mr-1" data-toggle="modal" @click="showMobilizerModal" v-if="((this.payrollStatus == 4 ) && (this.$global.user_vr_corp == 'NO' && this.corporateAccountBalance >= this.failedSumNetSalary && failedArray.length > 0))"> Reprocess </button>
                        </div>
                        <table id="displayFailedTable" class="table table-responsive-xl p-2" style="width:100%">
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Account Title</th>
                                    <th>Category</th>
                                    <th>Fee</th>
                                    <th>Net Payable</th>
                                    <th>Purpose of Payment</th>
                                    <th>Pay</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(failed, index) in failedArray" :key="index">
                                    <td> 
                                        <div class="image-title employe-detail-tooltip" :id="`employe-detail-tooltip1-${failed.id}`">
                                        {{ employeeFailedDetails(failed) }}
                                        </div>
                                    </td>
                                    <td>{{employeeAccountTitle(failed.payee_employee_beneficiary)}}</td>
                                    <td>{{failed.categoryname}}</td>
                                    <td>{{parseFloat(failed.transactionfee) + parseFloat(failed.transactionfed)}}</td>
                                    <td>{{(failed.net_salary)}}</td>
                                    <td>{{failed.reason}}</td>
                                    <td>Pay</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div> -->
        </div>
    </template>
    <template v-else-if="payments === null">
        <preLoader></preLoader>
    </template>
    <template v-else-if="payments === false">
        <notAllowed></notAllowed>
    </template>
    </div>
</template>

<script>
    var that;
    var myTable = null;
    import virtualAccountComponent from '../modals/virtualAccountComponent';
    import fincaComponent from '../modals/fincaComponent';
    import meezanComponent from '../modals/meezanComponent';
    import nbpFundsComponent from '../modals/nbpFundsComponent';
    import easypaisaComponent from '../modals/easypaisaComponent';
    import faysalComponent from '../modals/faysalComponent';
    export default {
        components: {
            virtualAccountComponent,
            fincaComponent,
            meezanComponent,
            nbpFundsComponent,
            easypaisaComponent,
            faysalComponent
        },
        data() {
            return {
                failedSumNetSalary:0,
                failedArray:null,
                payrollStatus : '123',
                meezan_balance : '',
                account_status: '',
                account_msg : '',
                exportBatch: false,
                currentUserImage:null,
                currentUserName: null,
                currentUserRole:null,
                currentUserFirstLetter:null,
				users : null,
				payrollList: null,
                actual_status: null,
				advanceSalary: null,
				payrollTotalAmount: null,
				payrollName: null,
				batchHistory: null,
				payrollDate: null,
				failedTransactions: false,
				unRegisterWalletCount: null,
                payroll_id: this.$route.params.id,
                batchId: null,
                transationfeeSum:0,
                pendingTxnCount:0,
                pendingTxnAmount:0,
                reject_comment: '',
                reupload_comment: '',
                flag_comment: '',
                row_id: '',
                corporateAccountBalance: 0,
                comment_parent_id: 0, // parent comment
                paymentEngine: '',
                recordAction: '',

				// flow data // test phase - all true
                mca: false,
				flagTD: false,
                payTD: false,
                currentStatus:0,
				statusTD: false,
				downloadTD: false,
				sendForApproverButton: false,
				sendForCheckerButton: false,
				batchStatusButton: false,
				deletButton: false,
				archiveBatchButton: false,
				archiveBatchAndDuplicateButton: false,
				reUploadButton: false,
				disapproveButton: false,
				approverRejectButton:false,
				processButton: false,

                // already action performed
                isAlreadySent: false,
                isAlreadyCheck: false,
                isAlreadyApproved: false,
				// payroll payment process permissions
				payments: null,
				create_payroll_batch: null,
				delete_payroll_batch: null,
				payroll_send_to_approver: null,
				payroll_send_to_checker: null,
				payroll_process_batch: null,
				payroll_reject_batch: null,
				payroll_disapprove_batch: null,
				payroll_hold_payment: null,
                payroll_archive: null,
                payroll_status: null,

                commentAction:null,
                formDisapprove: new Form({
                 comment:'',
                 payroll_id:''
                }),
                formReject: new Form({
                 comment:'',
                 payroll_id: ''
                }),
                formReUpload : new Form({
                 comment:'',
                 payroll_id: ''
                }),
                beforePayementBatchSummary:false,
                afterPayementBatchSummary:false,
                successTxn:null,
                successTxnAmount:null,
                failedTxn:null,
                failedTxnAmount:null,
                payableTxn:null,
                payableTxnAmount: null,
                search : '',
            };
		},
        updated(){

        },
        mounted() {
            that = this;
            var permission=false;
            this.$Progress.start();
			this.can('payments|create_payroll_batch|delete_payroll_batch|payroll_send_to_approver|payroll_send_to_checker|payroll_process_batch|payroll_reject_batch|payroll_disapprove_batch|payroll_hold_payment|payroll_archive|payroll_status').then(result => {
				// payroll payment process permissions
                permission = result.payments;
                this.create_payroll_batch = result.create_payroll_batch;
                this.delete_payroll_batch = result.delete_payroll_batch;
                this.payroll_send_to_approver = result.payroll_send_to_approver;
                this.payroll_send_to_checker = result.payroll_send_to_checker;
                this.payroll_process_batch = result.payroll_process_batch;
                this.payroll_reject_batch = result.payroll_reject_batch;
                this.payroll_disapprove_batch = result.payroll_disapprove_batch;
                this.payroll_hold_payment = result.payroll_hold_payment;
                this.payroll_archive = result.payroll_archive;
                this.payroll_status = result.payroll_status;
            }).then(result => {
                if(permission == true){
                    this.getCorporateCompanyBalance();
                    this.getFailedTransactions();
					axios.get('/api/getBatchSheetData/'+this.$route.params.id)
					.then(res => {
						if(res.status == 200){
                            $('.selectpicker').selectpicker('refresh');
                            this.meezan_balance = res.data.meezan_balance;
                            this.account_status = res.data.account_status;
                            if(this.account_status !== '' || this.account_status !== null){
                                if(this.account_status.status == 400){
                                    this.account_msg = this.account_status.msg;
                                }
                            }
                            this.actual_status = res.data.actual_status;
                            this.currentUserImage = res.data.currentUser.image;
                            this.currentUserName = res.data.currentUser.userName;
                            this.currentUserFirstLetter = res.data.currentUser.firstLetter;
                            this.currentUserRole = res.data.currentUser.role;
							this.users = res.data.users;
                            this.comments = res.data.comments;
							this.payroll_id = res.data.payrolllist.id;
							this.payrollList = res.data.payrolllist;
                            this.payrollStatus = res.data.payrolllist.status;
							this.advanceSalary = res.data.advanceSalary;
							this.batchId = res.data.batchId;
							this.failedTransactions = res.data.failedTransactions;
                            this.unRegisterWalletCount = res.data.unRegisterWalletCount;
                            this.exportBatch = true;
                            this.successTxn = res.data.successTxn;
                            this.successTxn = res.data.successTxn;
                            this.pendingTxnCount = res.data.pendingTxnCount;
                            this.pendingTxnAmount = res.data.pendingTxnAmount;
                            this.failedTxn = res.data.failedTxn;
                            this.failedTxnAmount = res.data.failedTxnAmount;
                            this.transationfeeSum = res.data.transationfeeSum;
                            this.payableTxn = res.data.totalPayableCount;
                            this.payableTxnAmount = res.data.totalPayableAmount;
							this.setBatchHistory(res);
							this.batchFlow(res);
							this.setPayrollDate(res.data.payrolllist);
                            this.getPaymentEngineData();
                            this.formDisapprove.payroll_id = res.data.payrolllist.id;
                            this.formReject.payroll_id = res.data.payrolllist.id;
                            this.formReUpload.payroll_id = res.data.payrolllist.id;
                            this.isAlreadySent = res.data.isAlreadySent;
                            this.isAlreadyCheck = res.data.isAlreadyCheck;
                            this.isAlreadyApproved = res.data.isAlreadyApproved;
                            if( this.create_payroll_batch == true && parseInt(this.payrollList.status) == '7'){ // flagged
                                this.reUploadButton = true;
                            }
                            this.deletButton=this.delete_payroll_batch;
                            this.sendForApproverButton=this.payroll_send_to_approver;
                            this.sendForCheckerButton=this.payroll_send_to_checker;
                            this.processButton = this.payroll_process_batch;
                            this.approverRejectButton=this.payroll_reject_batch;
                            this.disapproveButton=this.payroll_disapprove_batch;
                            if(this.payroll_archive == true && parseInt(this.payrollList.status) == '11'){ //Error status
                                this.archiveBatchButton=true;
                                this.archiveBatchAndDuplicateButton=true;
                            }
                            if(this.payroll_status == true && parseInt(this.payrollList.status) == '10'){ // inProcess
                                this.batchStatusButton = true;
                            }
                            // this.payments=true;
                            this.$Progress.finish();
                        }else{
							this.$Progress.fail();
						}
					}).then(res =>{
                        myTable = $('#dt-payroll-payments').DataTable({
                            "sDom": '<"row view-filter"<"clearfix">><"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
                            "searching":true,
                            columnDefs: [ {
                                orderable: false,
                                targets:   0
                            }],
                            order: [[ 0, "desc" ]],
                            drawCallback: function() {

                            }
                            });
                        $('#customSearch').on( 'keyup', function (e) {
                            if (e.keyCode === 13) {
                                myTable.search( this.value ).draw();
                            }
                        });
                    }).catch(err => {
						this.$Progress.fail();
					});
                }else{
                    this.payments=false;
                    this.$Progress.finish();
                }
            });

        },
        created() {
			//
		},
        watch : {
            failedArray(){
                this.failedArray.forEach(val => {
                    this.failedSumNetSalary += val.net_salary;
                });
            }
        },
		methods: {
            showMobilizerModal(){
                // EventBus.$emit('paymentReprocess', true);
                $('#displayFailed').modal('hide');
                $('#loginMoblizer').modal('show');
            },
            getFailedTransactions(){
                axios.post('/api/getFailedEmployeeBatch/'+ this.$route.params.id, {
                    batchType: 'failed' })
                .then((response) => {
                    if(response.status == 200){
                        this.failedArray = response.data;
                    }else{
                        this.showAlertBox('error','There is some problem');
                    }
                }).then((response)=>{
                    $('#displayFailedTable').DataTable({
                        "sDom": '<"row view-filter"<"clearfix">><"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
                        "searching":true,
                        columnDefs: [ {
                            orderable: false,
                            targets:   1
                        }],
                        order: [[ 1, "desc" ]],
                        drawCallback: function() {

                        }
                    });
                }).catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','There is some problem');
                });
            },
            showFailedModal(){
                $('#displayFailed').modal('show');
            },
            employeeAccountTitle(beneficiary){
                if(beneficiary !== null){
                    return beneficiary.account_title;
                }
            },
            employeeDetails(user){
                if(user.departmentname == null){
                    user.departmentname = '--';
                }
                if(user.branchname == null){
                    user.branchname = '--';
                }
                if(user.designationname == null){
                    user.designationname = '--';
                }
                if(user.cityname == null){
                    user.cityname = '--';
                }
                if(user.mobileNo == null){
                    user.mobileNo = '--';
                }
                var title = '<div class="emp-detail-tooltip">' +
                    '<p class="custom-tooltip-content">' +
                    '<span class="tooltip-col tooltip-title"> Department : </span>' +
                    '<span class="tooltip-col">'+user.departmentname+'</span>' +
                    '</p>' +
                    '<p class="custom-tooltip-content">' +
                    '<span class="tooltip-col tooltip-title"> Branch : </span>' +
                    '<span class="tooltip-col"> '+user.branchname+' </span>' +
                    '</p>' +
                    '<p class="custom-tooltip-content">' +
                    '<span class="tooltip-col tooltip-title"> Designation : </span>' +
                    '<span class="tooltip-col"> '+user.designationname+' </span>' +
                    '</p>' +
                    '<p class="custom-tooltip-content">' +
                    '<span class="tooltip-col tooltip-title"> City : </span>' +
                    '<span class="tooltip-col"> '+user.cityname+' </span>' +
                    '</p>' +
                    '<p class="custom-tooltip-content">' +
                    '<span class="tooltip-col tooltip-title"> Cell # : </span>' +
                    '<span class="tooltip-col"> '+user.mobileNo+' </span>' +
                    '</p>' +
                '</div>';
                setTimeout(function(){
                    $('#employe-detail-tooltip-'+user.id).tooltip({
                        title:title,
                        html: true,
                        placement: 'right',
                        offset: '80',
                        template: '<div class="tooltip custom-tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>'
                    });
                },100);
            },

            employeeFailedDetails(user){
                 return user.name;
            },
            sendToSecondApproverPopup(){
                $('.sendtoapprover').prop('disabled',false);
                $('#sendToSecondApproverPopup').modal('show');
            },
            sendtosecondapprover(){
                $('.sendtosecondapprover').prop('disabled',true);
                axios.get('/api/employeePaymentSendToSecondApprover/'+this.$route.params.id, {})
                    .then(res => {
                        if(res.data.status == 200){
                            this.showToastBox('success','Your Batch is Approved successfully');
                            $('#sendToSecondApproverPopup').modal('hide');
                            this.$router.push('/employeePayments');
                        }else{
                            this.showAlertBox('error',res.data.msg);
                        }
                    })
                    .catch(err => {
                        this.$Progress.fail();
                        this.showAlertBox('error','Error to load data');
                    });
            },
            reUploadPopup(){
               this.commentAction = 'reUpload';
               $('.reUpload').prop('disabled',false);
            },
            rejectApproverPopup(){
                 this.commentAction='reject';
                $('.reject').prop('disabled',false);
            },
            disapprovePopup(){
              $('.disapprove').prop('disabled',false);
               this.commentAction='disapprove';
            },
            updateRecordAction(recordId, e){
                that.recordAction = e.target.value;
                that.$Progress.start();
                axios.post("/api/updateRecordAction",{
                    action: that.recordAction,
                    recordId: recordId,
                    sheetStatus: that.payrollList.status,
                })
                    .then(res => {
                        if(res.status == 200){
                            that.payableTxn = res.data.data.totalPayableCount;
                            that.payableTxnAmount = res.data.data.totalPayableAmount;
                            that.$Progress.finish();
                        }else{
                            that.$Progress.fail();
                            that.showAlertBox('error','Error to load form data');
                        }
                    })
                    .catch(err => {
                        console.log(err);
                        that.$Progress.fail();
                        that.showAlertBox('error','Error to load form data');
                    });
            },
            showCommentBox: function(html,id){
                let that = this;
                that.row_id = id;
                var flagComment = '<div class="flag-comment-box clearfix">'+
                    '<div id="commentData">' + html + '</div>' +
                    '<div class="main-textbox mb-3"><textarea class="form-control" id="commentText"></textarea></div>' +
                    '<button class="btn btn-primary float-right" onclick="VueComponents.viewEmployeePaymentBatchSheetComponent.methods.addComment(event)"> Submit </button>' +
                    '</div>';
                $('[data-toggle="popover-click"]').popover({
                    html: true,
                    trigger: 'click',
                    placement: 'right',
                    sanitize: false,
                    content: flagComment,
                    template: '<div class="popover flaged-comment" role="tooltip"><div class="arrow"></div><div class="popover-body"></div></div>'
                });

                $(document).on( 'keyup', '#commentText',function () {
                    that.flag_comment = this.value;
                });
                $(document).mouseup(function(e)
                {
                    var container = $('.popover');
                    if (!container.is(e.target) && container.has(e.target).length === 0)
                    {
                        $('[data-toggle="popover-click"]').popover('hide');
                    }
                });
            },
            addComment: function(e){
                var id = that.$route.params.id;
                that.$Progress.start();
                that.flag_comment = $('#commentText').val();
                if(that.flag_comment == '' || that.flag_comment.length == 0){
                    that.showToastBox('warning','Please enter comment');
                    that.$Progress.finish();
                    return;
                }
                axios.post("/api/addEmployeeBatchComment",{
                    id: that.row_id,
                    flag_comment: that.flag_comment,
                    comment_parent_id: that.comment_parent_id,
                    })
                    .then(res => {
                        if(res.status == 200){
                            that.$Progress.finish();
                            $('#commentData').html(res.data.data);
                            $('#commentText').val('');
                            //this.getUserData(id);
                            /*$('[data-toggle="popover"]').popover();*/
                        }else{
                            that.$Progress.fail();
                            that.showAlertBox('error','Error to load form data');
                        }
                    })
                    .catch(err => {
                        console.log(err);
                        that.$Progress.fail();
                        that.showAlertBox('error','Error to load form data');
                    });
            },
            getUserData: function(id){
                axios.get('/api/getBatchUserData/'+id)
                    .then(res => {
                        if(res.status == 200){
                            this.users = res.data.users;
                        }
                    }).catch(err => {
                    console.log(err);
                });
            },
            getPaymentEngineData: function(){
                this.$Progress.start();
                axios.post("/api/getPaymentEngine")
                    .then(res => {
                        if(res.status == 200){
                            this.paymentEngine = res.data.data;
                            this.$Progress.finish();
                        }else{
                            this.$Progress.fail();
                            this.showAlertBox('error','Error to load form data');
                        }
                    })
                    .catch(err => {
                        console.log(err);
                        this.$Progress.fail();
                        this.showAlertBox('error','Error to load form data');
                    });
            },
			employeeSalary(JsonObject, id){
				var obj = JSON.parse(JsonObject);
				var basic_salary, housing_allowance, medical_allowance, car_allowance, fuel_allowance, other_allowance,conveyance,utility,cola;
				if(obj.basic_salary) {
					basic_salary = obj.basic_salary;
				} else {
					basic_salary = 0;
				}
				if(obj.housing_allowance) {
					housing_allowance = obj.housing_allowance;
				} else {
					housing_allowance = 0;
				}
                if(obj.conveyance) {
                    conveyance = obj.conveyance;
                } else {
                    conveyance = 0;
                }
				if(obj.medical_allowance) {
					medical_allowance = obj.medical_allowance;
				} else {
					medical_allowance = 0;
				}
				if(obj.car_allowance) {
					car_allowance = obj.car_allowance;
				} else {
					car_allowance = 0;
				}
				if(obj.fuel_allowance) {
					fuel_allowance = obj.fuel_allowance;
				} else {
					fuel_allowance = 0;
				}
				if(obj.other_allowance) {
					other_allowance = obj.other_allowance;
				} else {
					other_allowance = 0;
				}
                if(obj.utility) {
                    utility = obj.utility;
                } else {
                    utility = 0;
                }
                if(obj.cola) {
                    cola = obj.cola;
                } else {
                    cola = 0;
                }
                $("#salary-detail-"+id).tooltip({
                    title: '<div class="employee-salray">' +
                                '<p class="custom-tooltip-content">' +
                                    '<span class="tooltip-col tooltip-title"> '+basic_salary+' </span>' +
                                    '<span class="tooltip-col"> Basic Salary </span>' +
                                '</p>' +
                                '<p class="custom-tooltip-content">' +
                                    '<span class="tooltip-col tooltip-title"> '+housing_allowance+' </span>' +
                                    '<span class="tooltip-col"> Housing Allowance </span>' +
                                '</p>' +
                                '<p class="custom-tooltip-content">' +
                                    '<span class="tooltip-col tooltip-title"> '+medical_allowance+' </span>' +
                                    '<span class="tooltip-col"> Medical Allowance </span>' +
                                '</p>' +
                                '<p class="custom-tooltip-content">' +
                                    '<span class="tooltip-col tooltip-title"> '+car_allowance+' </span>' +
                                    '<span class="tooltip-col"> Car Allowance </span>' +
                                '</p>'+
                                '<p class="custom-tooltip-content">' +
                                    '<span class="tooltip-col tooltip-title"> '+fuel_allowance+' </span>' +
                                    '<span class="tooltip-col"> Fuel Allowance </span>' +
                                '</p>'+
                                '<p class="custom-tooltip-content">' +
                                    '<span class="tooltip-col tooltip-title"> '+other_allowance+' </span>' +
                                    '<span class="tooltip-col"> Other Allowance </span>' +
                                '</p>'+
                                '<p class="custom-tooltip-content">' +
                                '<span class="tooltip-col tooltip-title"> '+utility+' </span>' +
                                '<span class="tooltip-col"> Utility </span>' +
                                '</p>' +
                                '<p class="custom-tooltip-content">' +
                                '<span class="tooltip-col tooltip-title"> '+cola+' </span>' +
                                '<span class="tooltip-col"> Cola </span>' +
                                '</p>' +
                                '<p class="custom-tooltip-content">' +
                                '<span class="tooltip-col tooltip-title"> '+conveyance+' </span>' +
                                '<span class="tooltip-col"> Conveyance </span>' +
                                '</p>'+
                            '</div>',
                    html: true,
                    placement: 'right',
                    offset: '40',
                    template: '<div class="tooltip employee-salary-detail custom-tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>'
			    });
				var total_salary = parseInt(basic_salary) + parseInt(utility) + parseInt(cola) + parseInt(conveyance) + parseInt(housing_allowance) + parseInt(medical_allowance) + parseInt(car_allowance) + parseInt(fuel_allowance) + parseInt(other_allowance);
				var total_salary = new Intl.NumberFormat().format(total_salary);
				if(total_salary == 0){
					return '---';
				}else{
					return total_salary;
				}
			},
			additionEarnings(JsonObject, id){
				var obj = JSON.parse(JsonObject);
				var overtime, bonus, commission, other_additional_earning,one_time;
				if(obj.overtime) {
					overtime = obj.overtime;
				} else {
					overtime = 0;
				}
				if(obj.bonus) {
					bonus = obj.bonus;
				} else {
					bonus = 0;
				}
				if(obj.commission) {
					commission = obj.commission;
				} else {
					commission = 0;
				}
				if(obj.other_additional_earning) {
					other_additional_earning = obj.other_additional_earning;
				} else {
					other_additional_earning = 0;
				}
                if(obj.one_time) {
                    one_time = obj.one_time;
                } else {
                    one_time = 0;
                }
				var total_additional_earning = parseInt(overtime) + parseInt(bonus) + parseInt(commission) + parseInt(other_additional_earning) + parseInt(one_time);
				var total_additional_earning = new Intl.NumberFormat().format(total_additional_earning);
                $("#addition-earnings-detail-"+id).tooltip({
                    title: '<div class="employee-salray employee-additional-earnings">' +
                                '<p class="custom-tooltip-content">' +
                                    '<span class="tooltip-col tooltip-title"> '+overtime+' </span>' +
                                    '<span class="tooltip-col"> Overtime </span>' +
                                '</p>' +
                                '<p class="custom-tooltip-content">' +
                                    '<span class="tooltip-col tooltip-title"> '+bonus+' </span>' +
                                    '<span class="tooltip-col"> Bonus </span>' +
                                '</p>' +
                                '<p class="custom-tooltip-content">' +
                                    '<span class="tooltip-col tooltip-title"> '+commission+' </span>' +
                                    '<span class="tooltip-col"> Commission </span>' +
                                '</p>' +
                                '<p class="custom-tooltip-content">' +
                                    '<span class="tooltip-col tooltip-title"> '+other_additional_earning+' </span>' +
                                    '<span class="tooltip-col"> Other additional earning </span>' +
                                '</p>' +
                                '<p class="custom-tooltip-content">' +
                                '<span class="tooltip-col tooltip-title"> '+one_time+' </span>' +
                                '<span class="tooltip-col"> One Time </span>' +
                                '</p>' +
                            '</div>',
                    html: true,
                    placement: 'right',
                    offset: '40',
                    template: '<div class="tooltip employee-salary-detail custom-tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>'
                });
				if(total_additional_earning == 0){
					return '---';
				}else{
					return total_additional_earning;
				}
			},
			otherReimbursment(JsonObject, id){
				var obj = JSON.parse(JsonObject);
				var fuelreimbursement, travelingreimbursement, reimbursements;
				if(obj.fuelreimbursement) {
					fuelreimbursement = obj.fuelreimbursement;
				} else {
					fuelreimbursement = 0;
				}
				if(obj.travelingreimbursement) {
					travelingreimbursement = obj.travelingreimbursement;
				} else {
					travelingreimbursement = 0;
				}
				if(obj.reimbursements) {
					reimbursements = obj.reimbursements;
				} else {
					reimbursements = 0;
				}
                
				var totalreimbursement = parseInt(fuelreimbursement) + parseInt(travelingreimbursement) + parseInt(reimbursements);
				var totalreimbursement = new Intl.NumberFormat().format(totalreimbursement);
                $("#other-reimbursment-detail-"+id).tooltip({
                    title: '<div class="employee-salray employee-other-reimbursements">' +
                                '<p class="custom-tooltip-content">' +
                                    '<span class="tooltip-col tooltip-title"> '+totalreimbursement+' </span>' +
                                    '<span class="tooltip-col"> Other Reimbursements </span>' +
                                '</p>' +
                            '</div>',
                    html: true,
                    placement: 'right',
                    offset: '0',
                    template: '<div class="tooltip other-reimbursement-tooltip custom-tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>'
			    });
                if(totalreimbursement == 0){
					return '---';
				}else{
					return totalreimbursement;
				}
			},
			deduction(JsonObject, id){
				var obj = JSON.parse(JsonObject);
				var income_tax, eobi, provident_fund, other_deduction, outstanding_advance_salary, fees_advance_salary, advances;
				if(obj.income_tax) {
					income_tax = obj.income_tax;
				} else {
					income_tax = 0;
				}
				if(obj.eobi) {
					eobi = obj.eobi;
				} else {
					eobi = 0;
				}
				if(obj.provident_fund) {
					provident_fund = obj.provident_fund;
				} else {
					provident_fund = 0;
				}
				if(obj.other_deduction) {
					other_deduction = obj.other_deduction;
				} else {
					other_deduction = 0;
				}
				if(obj.outstanding_advance_salary) {
					outstanding_advance_salary = obj.outstanding_advance_salary;
				} else {
					outstanding_advance_salary = 0;
				}
				if(obj.fees_advance_salary) {
					fees_advance_salary = obj.fees_advance_salary;
				} else {
					fees_advance_salary = 0;
				}
                if(obj.advances) {
                    advances = obj.advances;
                } else {
                    advances = 0;
                }
				var deduction = parseInt(income_tax) + parseInt(eobi) + parseInt(provident_fund) + parseInt(other_deduction) + parseInt(outstanding_advance_salary) + parseInt(fees_advance_salary) + parseInt(advances);
				var deduction = new Intl.NumberFormat().format(deduction);
                $("#deduction-detail-"+id).tooltip({
                    title: '<div class="employee-salray employee-additional-earnings">' +
                                '<p class="custom-tooltip-content">' +
                                    '<span class="tooltip-col tooltip-title"> '+ income_tax +' </span>' +
                                    '<span class="tooltip-col"> Income Tax </span>' +
                                '</p>' +
                                '<p class="custom-tooltip-content">' +
                                    '<span class="tooltip-col tooltip-title"> '+ eobi +' </span>' +
                                    '<span class="tooltip-col"> EOBI </span>' +
                                '</p>' +
                                '<p class="custom-tooltip-content">' +
                                    '<span class="tooltip-col tooltip-title"> '+ provident_fund +' </span>' +
                                    '<span class="tooltip-col"> Provident Fund </span>' +
                                '</p>' +
                                '<p class="custom-tooltip-content">' +
                                '<span class="tooltip-col tooltip-title"> '+ advances +' </span>' +
                                '<span class="tooltip-col"> Advances </span>' +
                                '</p>' +
                                '<p class="custom-tooltip-content">' +
                                '<span class="tooltip-col tooltip-title"> '+ other_deduction +' </span>' +
                                '<span class="tooltip-col"> Others </span>' +
                                '</p>' +
                            '</div>',
                    html: true,
                    placement: 'right',
                    offset: '40',
                    template: '<div class="tooltip other-reimbursement-tooltip custom-tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>'

                });
				if(deduction == 0){
					return '---';
				}else{
					return deduction;
				}
			},
			netPayable(JsonObject, mobileNo, payrollList, advanceSalary){
				var salary = 0;
				var obj = JSON.parse(JsonObject);
				var income_tax, eobi, provident_fund, other_deduction, outstanding_advance_salary, fees_advance_salary;
				if(obj.income_tax) {
					income_tax = obj.income_tax;
				} else {
					income_tax = 0;
				}
				if(obj.eobi) {
					eobi = obj.eobi;
				} else {
					eobi = 0;
				}
				if(obj.provident_fund) {
					provident_fund = obj.provident_fund;
				} else {
					provident_fund = 0;
				}
				if(obj.other_deduction) {
					other_deduction = obj.other_deduction;
				} else {
					other_deduction = 0;
				}
				if(payrollList.status != 4 && payrollList.status != 5){
                    // if(isset(advanceSalary[$user->mobileNo])){
                    //     $totalLoan = $advanceSalary[$user->mobileNo]['charges'] + $advanceSalary[$user->mobileNo]['outstanding'];
                    //     if($user->net_salary < $totalLoan){
                    //         $salary += $user->net_salary;
                    //     }else{
                    //         $salary += $advanceSalary[$user->mobileNo]['charges'] + $advanceSalary[$user->mobileNo]['outstanding'];
                    //     }
                    // }
                }else{
					if(obj.outstanding_advance_salary) {
						outstanding_advance_salary = obj.outstanding_advance_salary;
					} else {
						outstanding_advance_salary = 0;
					}
					if(obj.fees_advance_salary) {
						fees_advance_salary = obj.fees_advance_salary;
					} else {
						fees_advance_salary = 0;
					}
                }
				var deduction = parseInt(income_tax) + parseInt(eobi) + parseInt(provident_fund) + parseInt(other_deduction) + parseInt(outstanding_advance_salary) + parseInt(fees_advance_salary);
				var deduction = new Intl.NumberFormat().format(deduction);
				if(deduction == 0){
					return '---';
				}else{
					return deduction;
				}
			},
			setBatchHistory(res){
				this.batchHistory = res.data.history;
				this.payrollTotalAmount = res.data.payrolllist.payroll_amount;
				if(this.payrollList.name != ''){
					this.payrollName = this.payrollList.name;
				}else{
					var date = this.payrollList.created_at;
					this.payrollName = ''+moment(date).format('M')+'';
				}

			},
			setPayrollDate(payrollList){
				if(payrollList.payroll_type == 'PAYROLL'){
					if(payrollList.payroll_frequency == 'TIMEPERIOD'){
						if(!(payrollList.to_date == '' && payrollList.from_date == '')){
							var to_return = moment(payrollList.from_date).format('MMM D, Y')+' - '+moment(payrollList.to_date).format('MMM D, Y');
						}
					}else if(payrollList.payroll_frequency == 'ONETIME'){
						var to_return = ''+moment(payrollList.created_at).format('MMM D, Y')+'';
					}else{
						var to_return = moment(payrollList.from_date).format('MMM D, Y')+' - '+moment(payrollList.to_date).format('MMM D, Y');
					}
				}
				this.payrollDate = to_return;
				return this.payrollDate;
			},
			batchFlow(res){
                var status = res.data.payrolllist.status;
                this.currentStatus = status;
                if(status == 1 || status == 2 || status == 3 || status == 7 || status == 8){
                    this.beforePayementBatchSummary = true;
                }
                if(status == 4 || status == 5 || status == 11 || status == 10){
                    this.afterPayementBatchSummary = true;
                }
				if(res.data.payrolllist.status != 4 && res.data.payrolllist.status != 5){
					if(this.create_payroll_batch){
						if(res.data.payrolllist.status == 7 || res.data.payrolllist.status == 6){
							this.flagTD = true;
						}
					}
					if(this.payroll_send_to_approver || this.payroll_process_batch){
						this.flagTD = true;
					}
				}
				if(this.payroll_hold_payment){
					this.payTD = true;
				}
				if(res.data.payrolllist.status == 4 || res.data.payrolllist.status == 5){
					this.statusTD = true;
					this.downloadTD = true;
				}
                if(res.data.payrolllist.status == 1 || res.data.payrolllist.status == 2 || res.data.payrolllist.status == 3 ){
					this.mca = true;
				}


			},
			sendForChecker(){
				var payroll_id = this.payroll_id;
				this.$Progress.start();
                $('#sendToChecker').modal('hide');
                axios.post('/api/employeeSendToChecker',{
					payroll_id: payroll_id
				})
                .then(res => {
                    if(res.status == 200){
                        if(res.data.code == 200){
                            this.$Progress.finish();
                            if(this.$global.nextMaker == ''){
                                this.showToastBox('success','Batch successfully sent to checker');
                            }else{
                                this.showToastBox('success','Batch successfully sent to '+this.$global.nextMaker);
                            }
                            this.$router.push('/employeePayments');
                        }else{
                            this.showAlertBox('error',res.data.msg);
                        }
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error','There is some problem');
                    }

                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','There is some problem');
                });
			},
			sendForApprover(){
				var payroll_id = this.payroll_id;
				this.$Progress.start();
                $('#sendToApprover').modal('hide');
                axios.post('/api/employeeSendToApprover',{
					payroll_id: payroll_id
				})
                .then(res => {
                    if(res.status == 200){
                        if(res.data.code == 200){
                            this.$Progress.finish();
                            if(this.$global.nextChecker == ''){
                                this.showToastBox('success','Batch successfully sent to approver');
                            }else{
                                this.showToastBox('success','Batch successfully sent to '+this.$global.nextChecker);
                            }
                            this.$router.push('/employeePayments');
                        }else{
                            this.showAlertBox('error',res.data.msg);
                        }
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error','There is some problem');
                    }

                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','There is some problem');
                });
			},
			batchStatus(){
				var payroll_id = this.payroll_id;
				this.$Progress.start();
                axios.post('/api/batchStatus',{
					payroll_id: payroll_id
				})
                .then(res => {
                    if(res.status == 200){
						this.$Progress.finish();
						if(res.data.code == 403){
							this.showToastBox('info',res.data.data);
						}else if(res.data.code == 200){
                            this.showToastBox('success',res.data.data);
                        }
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error','There is some problem');
                    }

                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','There is some problem');
                });
			},
			deleteBatch(){
				var payroll_id = this.payroll_id;
				this.$Progress.start();
                $('#deleteBatch').modal('hide');
                axios.post('/api/deleteBatch',{
					payroll_id: payroll_id
				})
                .then(res => {
                    if(res.status == 200){
                        this.$Progress.finish();
                        this.showToastBox('success','Batch successfully deleted');
                        this.$router.push('/employeePayments');
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error','There is some problem');
                    }

                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','There is some problem');
                });
			},
			archiveBatch(){
				var payroll_id = this.payroll_id;
				this.$Progress.start();
                $('#archiveBatch').modal('hide');
                axios.post('/api/archiveBatch',{
					payroll_id: payroll_id
				})
                .then(res => {
                    if(res.status == 200){
                        this.$Progress.finish();
                        this.showToastBox('success','Batch successfully archived');
                        this.$router.push('/employeePayments');
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error','There is some problem');
                    }

                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','There is some problem');
                });
			},
			archiveAndDuplicateBatch(){
				var payroll_id = this.payroll_id;
				this.$Progress.start();
                $('#archiveAndDuplicateBatch').modal('hide');
                axios.post('/api/archiveAndDuplicateBatch',{
					payroll_id: payroll_id
				})
                .then(res => {
                    if(res.status == 200){
                        this.$Progress.finish();
                        this.showToastBox('success','Batch successfully archived and duplicated');
                        this.$router.push('/employeePayments');
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error','There is some problem');
                    }

                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','There is some problem');
                });
			},
			reuploadBatch(){
                var payroll_id = this.payroll_id;
                $('.reUpload').prop('disabled',true);
				this.$Progress.start();
                this.formReUpload.post('/api/reuploadBatch')
                .then(res => {
                    if(res.status == 200){
                        this.$Progress.finish();
                        this.$router.push('/generatePaymentBatch?payroll_id='+payroll_id);
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error','There is some problem');
                    }

                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','There is some problem');
                });
			},
			disapproveBatch(){
                $('.disapprove').prop('disabled',true);
				this.$Progress.start();
                this.formDisapprove.post('/api/disapproveBatch')
                .then(res => {
                    if(res.status == 200){
                        this.$Progress.finish();
                        toast.fire({
                            type: 'success',
                            title: 'Batch successfully disapproved'
                        });
                        this.$router.push('/employeePayments');
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error','There is some problem');
                    }

                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','There is some problem');
                });
			},
            rejectBatch(){
                $('.reject').prop('disabled',true);
                this.$Progress.start();
                this.formReject.post('/api/rejectPayroll')
                    .then(res => {
                        if(res.status == 200){
                            this.$Progress.finish();
                            this.showToastBox('success','Batch successfully revised');
                            this.$router.push('/employeePayments');
                        }else{
                            this.$Progress.fail();
                            this.showAlertBox('error','There is some problem');
                        }

                    })
                    .catch(err => {
                        this.$Progress.fail();
                        this.showAlertBox('error','There is some problem');
                    });
            },
            downloadSalarySlip: function(id){
                axios.get('/api/downloadMySalarySlip/'+id, {responseType: 'arraybuffer'})
                .then((response) => {
                    if(response.status == 200){
                        let blob = new Blob([response.data], { type: 'application/pdf' })
                        let link = document.createElement('a')
                        link.href = window.URL.createObjectURL(blob)
                        link.download = 'Salary Slip.pdf'
                        link.click();
                        toast.fire({
                            type: 'success',
                            title: 'File Downloaded Successfully'
                        });
                    }else{
                        this.showAlertBox('error','There is some problem');
                    }

                }).catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','There is some problem');
                });
            },
            unRegisterWalletExport: function () {
                this.$Progress.start();
                axios.post('/api/unRegisterWalletExport', {
                    id : this.payrollList.id,
                    batchId : this.batchId,
                },{
                    responseType: 'blob'
                }).then(res => {
                    if(res.status == 200){
                        const url = URL.createObjectURL(new Blob([res.data], {
                            type: 'application/vnd.ms-excel'
                        }))
                        const link = document.createElement('a')
                        link.href = url
                        link.setAttribute('download', 'EmployeeBatchUnRegisteredWallet.csv')
                        document.body.appendChild(link)
                        link.click();
                        this.$Progress.finish();
                    }else{
                        this.$Progress.fail();
                    }
                }).catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Some problem in your form data');
                });
            },
            failedTransactionsExport: function () {
                this.$Progress.start();
                axios.post('/api/failedTransactionsExport', {
                    id : this.payrollList.id },{
                    responseType: 'blob'
                }).then(res => {
                    if(res.status == 200){
                        const url = URL.createObjectURL(new Blob([res.data], {
                            type: 'application/vnd.ms-excel'
                        }))
                        const link = document.createElement('a')
                        link.href = url
                        link.setAttribute('download', 'EmployeeBatchFailed.csv')
                        document.body.appendChild(link)
                        link.click()
                        this.$Progress.finish();
                    }else{
                        this.$Progress.fail();
                    }
                }).catch(err => {
                        this.$Progress.fail();
                        this.showAlertBox('error','Some problem in your form data');
                });
            },
            batchExport: function (e) {
                var param = e.target.value;
                if(param !== ""){
                    this.$Progress.start();
                    axios.post('/api/batchExport', {
                        id : this.payrollList.id, batchType: param },{
                        responseType: 'blob'
                    }).then(res => {
                        if(res.status == 200){
                            const url = URL.createObjectURL(new Blob([res.data], {
                                type: 'application/vnd.ms-excel'
                            }))
                            const link = document.createElement('a')
                            link.href = url
                            link.setAttribute('download', 'EmployeeBatchList.csv')
                            document.body.appendChild(link)
                            link.click()
                            this.$Progress.finish();
                        }else{
                            this.$Progress.fail();
                        }
                    })
                    .catch(err => {
                        this.$Progress.fail();
                        this.showAlertBox('error','Some problem in your form data');
                    });
                }
            },

            getCorporateCompanyBalance: function(){
                this.$Progress.start();
                axios.get("/api/getCurrentBalanceData")
                    .then(res => {
                        if(res.status == 200){                            
                            this.corporateAccountBalance = res.data.data.balance;
                            this.$Progress.finish();
                        }else{
                            this.$Progress.fail();
                            this.showAlertBox('error','Error to load form data');
                        }
                        this.payments=true;
                        setTimeout(()=>{
                            $('.selectpicker').selectpicker();          
                        }, 0);

                    })
                    .catch(err => {
                        this.$Progress.fail();
                        this.showAlertBox('error','Error to load form data');
                    });
            },


            printBatch: function (e) {
                var param = e.target.value;
                if(param !== ""){
                    axios.post('/api/printEmployeeBatch/'+ this.$route.params.id, {
                    batchType: param })
                    .then((response) => {
                        if(response.status == 200){
                            var mywindow = window.open('', 'PRINT', 'height=400,width=600');
                            // mywindow.document.write('<html><head><title>' + document.title  + '</title>');
                            // mywindow.document.write('</head><body >');
                            // mywindow.document.write('<h1>' + document.title  + '</h1>');
                            mywindow.document.write(response.data);
                            // mywindow.document.write('</body></html>');
                            mywindow.document.close(); // necessary for IE >= 10
                            mywindow.focus(); // necessary for IE >= 10*/
                            mywindow.print();
                            // mywindow.close();
                            return true;
                        }else{
                            this.showAlertBox('error','There is some problem');
                        }

                    }).catch(err => {
                        this.$Progress.fail();
                        this.showAlertBox('error','There is some problem');
                    });
                }
                
            },

		}
    }
</script>
